import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
export var Duration = /*#__PURE__*/function () {
  function Duration() {
    _classCallCheck(this, Duration);
  }

  _createClass(Duration, null, [{
    key: "isValid",
    value: function isValid(value) {
      return value > 0;
    }
  }, {
    key: "toMillisecond",
    value: function toMillisecond(minute) {
      return minute * 60000;
    }
  }]);

  return Duration;
}();

_defineProperty(Duration, "customDuration", -1000);

_defineProperty(Duration, "minDuration", 15);

_defineProperty(Duration, "maxDuration", 120);

_defineProperty(Duration, "step", 5);

_defineProperty(Duration, "availableDurations", [].concat(_toConsumableArray(Array.from({
  length: Math.floor((Duration.maxDuration - Duration.minDuration) / Duration.step) + 1
}).map(function (_, index) {
  return Duration.minDuration + index * Duration.step;
})), [Duration.customDuration]));